import { jsx } from 'react/jsx-runtime';
import { I18nProvider } from '@lingui/react';
import { useEffect } from 'react';
import { i18n } from '../../../utils/i18n.js';
import { Idioma, IdiomaInfo } from '../../../utils/idioma.js';
import { Content } from '../components/content.js';
import { useTheme } from '../../core/hooks/useTheme.js';
import { PortalTour } from '../../core/providers/tour.js';

const Header = (props) => {
  const {
    currentUser: {
      idioma
    },
    breadcrumbProps,
    realm
  } = props;
  useTheme(realm);
  const idiomaAtual = Idioma[idioma?.id ?? "PT_BR"];
  useEffect(() => {
    i18n.activate(IdiomaInfo[idiomaAtual].language);
  }, [idiomaAtual]);
  return /* @__PURE__ */ jsx(I18nProvider, { i18n, children: /* @__PURE__ */ jsx(PortalTour, { steps: [], children: /* @__PURE__ */ jsx(Content, { ...props, breadcrumbProps }) }) });
};

export { Header };
